import React 			from 'react';

import BLComponent		from '../core/_BLComponent.jsx'
import InputLabelSet 	from '../common/_InputLabelSet.jsx';
import CustomCheckbox from '../common/_CustomCheckbox.jsx';
import CustomRadio 		from '../common/_CustomRadio.jsx';
import blAjax					from '../utils/_ajax.jsx';

import {ClickShowTooltip, onEscapePress} 	from '../common/_Utilities.jsx';


export default class LoginModal extends BLComponent
{
	constructor( props )
	{
		super( props );

		if ( !this.isRestoredFromContext() )
		{
			this.state = 
				{
					dummy:				0
				,	view:				'login'
				,	loginname:			''
				,	username:			''
				,	emailAddress:		''
				,	password:			''
				,	stayLoggedIn:		false
				,	errorLoginMsg:		''

				, hasEdited: {emailAddress: false, username: false, password: false}
				,	selectedCountry:	blapp.session.codeCountryDetected
				,	selectedState:		0
				,	typeState:			0			// 0 : No State, 1 : From Select, 2 : Text Input
				,	strTitleState:		"state"
				,	stateManual:		""
				,	errorRegisterMsg:	''

				,	passwordStrength: 	0
				,	marketingEmails: ''
				,	errorMarketing: false
				,	showDeactivatedError: false


				, showUpdatePwd: false
				,	showRecovery: false
				};
		}

		this.state.password	= '';	// For security reason, password should be reset always

		this._countries			= null;
		this._countryForState	= null;
		this._states			= null;

		this._checkUsers		= {};
		this.funcValidate		= _.debounce( ( chkval ) => this.checkDuplication( chkval ), 500 );
		this._isEmailValid		= false;
		this._isUsernameValid	= false;
		this._isPasswordValid	= false;

		this._isProcessing		= false;
	}

	componentDidMount()
	{
		this.updateStates( this.state.selectedCountry );
		onEscapePress(() => blapp.refs.get( "header" ).hideLogin('login'));
	}

	componentDidUpdate() {
		let {emailAddress, username, password} = this.state;
		let hasEdited = this.state.hasEdited;

		if(!this.state.hasEdited.emailAddress && emailAddress.length) {
			hasEdited.emailAddress = true;

			this.setState({hasEdited: hasEdited});
		}
		if(!this.state.hasEdited.username && username.length) {
			hasEdited.username = true;

			this.setState({hasEdited: hasEdited});
		}
		if(!this.state.hasEdited.password && password.length) {
			hasEdited.password = true;

			this.setState({hasEdited: hasEdited});
		}
		
		onEscapePress(() => blapp.refs.get( "header" ).hideLogin('login'));
	}

	render() 
	{
		if(this.state.showRecovery) {
			let urlParams = this.state.loginname.indexOf('@') != -1 ? `email=${this.state.loginname}` : `username=${this.state.loginname}`;

			return (
				<article className="modal">
					<div className="modal__overlay" onClick={() => blapp.refs.get( "header" ).toggleMenu('login')}></div>
					<div className="modal__content modal__content--login-register">
						<div className="modal__body text--center">
							<div className="text--right">
								<i className="far fa-times modal__close text--small-title" onClick={() => blapp.refs.get( "header" ).toggleMenu('login')}></i>
							</div>
							<h2 className="text--small-title text--bold l-margin-bottom--xl">Account verification needed</h2>
							<i className="text--sxl-title text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom--xl"/>
							<p className="l-margin-bottom--xl">We care about the safety of our members. Please verify your identity to make sure only you are accessing your account.</p>
							<a href={blapp.url2.getAccountRecoveryUrl(urlParams)} className="btn btn--cta text--bold l-block">Verify my identity</a>
						</div>
					</div>
				</article>
			);
		}else if(this.state.showUpdatePwd) {
			return (
				<article className="modal">
					<div className="modal__overlay" onClick={() => blapp.refs.get( "header" ).toggleMenu('login')}></div>
					<div className="modal__content modal__content--login-register">
						<div className="modal__body text--center">
							<div className="text--right">
								<i className="far fa-times modal__close text--small-title" onClick={() => blapp.refs.get( "header" ).toggleMenu('login')}></i>
							</div>
							<h2 className="text--small-title text--bold l-margin-bottom--xl">Please update your password</h2>
							<i className="text--sxl-title text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom--xl"/>
							<p className="l-margin-bottom--xl">We care about the safety of our members. Please update your password to access your account.</p>
							<a href={blapp.url2.getForgotPasswordUrl()} className="btn btn--cta text--bold l-block">Update password</a>
						</div>
					</div>
				</article>
			);
		}else{
			return (
				<div className="modal">
					<div className="modal__overlay" onClick={() => blapp.refs.get( "header" ).toggleMenu('login')}></div>
					<div className="modal__content modal__content--login-register">
						<div className="modal__header">
							<h2 className="text--small-title text--bold">{$T("LOG_IN")}</h2>
							<i className="far fa-times modal__close" onClick={() => blapp.refs.get( "header" ).toggleMenu('login')}></i>
						</div>
						{this.renderLoginForm()}
					</div>
				</div>
			);
		}
	}

	renderLoginForm()
	{
		const isDeactivated = this.state.showDeactivatedError; 

		return (
			<div className="modal__body">
				<InputLabelSet classes="l-margin-bottom l-margin-top--sm" data={{id: "logindlg_l_username", focus: true, label: $T("LBL_USERID"), inputValue: this.state.loginname, onChangeFunc: this.updateLoginname }}/>
				{isDeactivated && <span className="text--small l-margin-bottom--sm l-block text-color--primaryRed">This account is deactivated.</span>}
				<InputLabelSet classes="l-margin-bottom" data={{id: "logindlg_l_Password", label: $T("LBL_PASSWORD"), inputValue: this.state.password, onChangeFunc: this.updatePassword, onEnterFunc: () => this.login(), type: 'password', password: true, maxLength: '15'}}/>
				<div className="l-margin-bottom l-flex l-center">
					<CustomCheckbox isChecked={this.state.stayLoggedIn} onChangeFunc={this.changeStayLoggedIn} id="stayLoggedIn"/>
					<label htmlFor="stayLoggedIn" className="l-margin-left">{$T("STAY_LOGGEDIN")}</label>
				</div>
				{
					this.state.errorLoginMsg != '' ?
					(<div className="text-color--primaryRed text--center l-margin-bottom">{this.state.errorLoginMsg}</div>)
					:
					null
				}
				<button className="btn btn--cta l-full-width l-margin-bottom" onClick={() => this.login()}>
					{$T( "LOG_IN" )}
				</button>
				<a href={`${blapp.url2.getUrlInfoBase('/register/main.page').path}?returnTo=${window.location.href}`} className="btn btn--grey l-full-width l-margin-bottom l-block">
					{$T("CREATE_ACCOUNT")}
				</a>
				<a href={"//www.bricklink.com/help.asp?helpID=58"} className="l-block l-margin-bottom--xs">
					{$T("HAVING_TROUBLE")}
				</a>
				<a href={blapp.url2.getForgotPasswordUrl()} className="l-block l-margin-bottom--xs">
					{$T("FORGOT_PASSWORD")}
				</a>
			</div>
		);
	}

	renderRegisterForm()
	{
		var	valEmail 	= this.validateInput( 'emailAddress' );
		var valUsername	= this.validateInput( 'username' );
		var valPassword	= this.validateInput( 'password' );
		var	valState	= this.validateInput( 'state' ) || this.state.typeState == 0;
		var	isAllOK		= this._isEmailValid && this._isUsernameValid && this._isPasswordValid && valState;
		let hasEdited = this.state.hasEdited;

		return (
			<div className="modal__body">
				<div className="l-margin-bottom--sm">
					<span className="text--small-title">{$T("ACCOUNT")}</span>
				</div>
				<div className="l-margin-bottom">
					<InputLabelSet classes="l-margin-bottom--xs" data={{id: "logindlg_r_EmailAddress", type: "email", focus: true, label: $T( "LBL_EMAILADDRESS" ), inputValue: this.state.emailAddress, onChangeFunc: this.updateEmailAddress, validation: hasEdited.emailAddress ? (this._isEmailValid ? "ok" : "error") : ""}}/>
					<small className={"text--note" + (valEmail ? " text-color--primaryRed" : "")}>{valEmail ? valEmail : $T("EMAIL_NOTE")}</small>
				</div>
				<div className="l-margin-bottom">
					<InputLabelSet classes="l-margin-bottom--xs" data={{id: "logindlg_r_Username", label: $T( "LBL_USERNAME" ), inputValue: this.state.username, onChangeFunc: this.updateUsername, validation: hasEdited.username ? (this._isUsernameValid ? "ok" : "error") : "", maxLength: "15"}}/>
					<small className={"text--note" + (valUsername ? " text-color--primaryRed" : "")}>{valUsername ? valUsername : $T("USERNAME_NOTE")}</small>
				</div>
				<div className="l-margin-bottom">
					<InputLabelSet classes="l-margin-bottom--xs" data={{id: "logindlg_r_Password", label: $T( "LBL_PASSWORD" ), inputValue: this.state.password, onChangeFunc: this.updatePassword, type: 'password', password: true, validation: hasEdited.password ? (this._isPasswordValid ? "ok" : "error") : "", maxLength: "15" }}/>
					<small className="text--note">{valPassword ? this.renderPasswordStrength() : <span>{$T("PASSWORD_NOTE")}  <i className="fa fa-info-circle text-color--lighterDarkest" data-tooltip-width={200} data-tooltip={`Acceptable special characters: _.-[]/{}()*+?^$|~!@#%&()\`=;’,><:\”`} onClick={(e) => ClickShowTooltip(e)}></i></span>}</small>
				</div>
				<div className="l-margin-bottom--sm">
					<span className="text--small-title">{$T( "LOCATION" )}</span> <i className="fa fa-info-circle text-color--lighterDarkest" data-tooltip-width={200} data-tooltip="We use your location to find local stores and better personalize your shopping experience." onClick={(e) => ClickShowTooltip(e)}></i>
				</div>
				<select className="select l-full-width l-margin-bottom" value={this.state.selectedCountry} onChange={this.updateCountry}>
					{this.renderCountries()}
				</select>
				{this.renderStates()}
				{!valState && this.state.typeState != 0 ? <small className="text--note text-color--primaryRed">{$T("STATE_NOTE")}</small> : null}
				<div className="l-margin-bottom--sm l-margin-top">
					<span className="text--small-title">{$T( "MARKETING_EMAILS" )}</span>
					{this.state.errorMarketing &&
						<small className={"l-flex text-color--primaryRed"}>{$T("MARKETING_ERROR")}</small>
					}
				</div>
				<label className="l-flex l-margin-bottom--sm">
					<CustomRadio isChecked={this.state.marketingEmails === 'true'} onChangeFunc={this.changeMarketingEmails} value="true" id="marketing-yes" classes="l-margin-right"/>
					<p>{$T('MARKETING_YES')}</p>
				</label>
				<label className="l-flex l-margin-bottom--sm">
					<CustomRadio isChecked={this.state.marketingEmails === 'false'} onChangeFunc={this.changeMarketingEmails} value="false" id="marketing-no" classes="l-margin-right"/>
					<p>{$T('MARKETING_NO')}</p>
				</label>

				<div className="text--note l-margin-y">
					{$T("CONSENT")}
				</div>
				{
					this.state.errorRegisterMsg != '' ?
					(<div className="text-color--primaryRed text--center l-margin-bottom">{this.state.errorRegisterMsg}</div>)
					:
					null
				}				
				<button className="btn btn--cta l-full-width l-margin-bottom" onClick={this.register} disabled={!isAllOK}>
					{$T("CREATE_ACCOUNT")}
				</button>
				<a href={blapp.url2.getUrlInfoBase('/register/main.page').path} className="l-block btn--link">
					{$T("ALREADY_MEMBER")}
				</a>
			</div>
		);
	}

	validateInput( type ) 
	{
		switch ( type ) 
		{
			case 'emailAddress':
				this._isEmailValid	= false;

				if ( this._checkUsers[ this.state.emailAddress ] != null )
					return $T( "ERR_SIGNUP_EMAIL_EXIST" );
				else if ( this.state.emailAddress == "" || !blapp.util.isValidEmailAddr( this.state.emailAddress ) )
					return "";

				this._isEmailValid	= true;
				return "";

			case 'username':
				this._isUsernameValid	= false;
				if ( this._checkUsers[ this.state.username ] != null )
					return $T( "ERR_SIGNUP_USERNAME_EXIST" );
				else if ( this.state.username.length > 15 )
					return $T( "ERR_SIGNUP_USERNAME_TOO_LONG" );
				else if ( this.state.username == "" )
					return "";

				this._isUsernameValid	= true;
				return "";

			case 'password':
				if ( this.state.password != null && this.state.password.length >= 8 && this.state.password.length <= 15 && this.state.password.indexOf( ' ' ) == -1 )
				{
					this._isPasswordValid	= true;
					return true;
				}

				this._isPasswordValid	= false;
				return false;

			case 'state':
				if ( ( this.state.typeState == 1 && this.state.selectedState > 0 ) 
					|| ( this.state.typeState == 2 && this.state.stateManual.trim() != "" ) )
				{
					return true;
				}

				return false;
		}
	}

	checkDuplication( chkVal )
	{
		if ( this._checkUsers[ chkVal ] != null )
			return;

		blapp.models.fetch(
			"_checkuser"
		,	{ 
				controller: "user.BLCUserBasic"
			,	method: 	"checkExists"
			,	params: 	[ chkVal ]
			,	refresh:	true 
			}
		).then(
			( data ) =>
			{
				if ( data != null && data === true )
				{
					this._checkUsers[ chkVal ]	= chkVal;
					this.setState( { dummy: this.state.dummy + 1 } );
				}
			}
		).catch(
			( err ) => console.log( err )
		);
	}

	renderPasswordStrength()
	{
		const passwordStrength 		= this.state.passwordStrength;
		const passwordStrengthVerbs = [ $T( "PWD_STRENGTH_WEAK" ), $T( "PWD_STRENGTH_MODEST" ), $T( "PWD_STRENGTH_GOOD" ), $T( "PWD_STRENGTH_STRONG" ) ];

		return (
			<span>
				{$T('PASSWORD_STRENGTH')}: {passwordStrengthVerbs[passwordStrength]}
				&nbsp;
				<ul className={"password-strength-notification password-strength-notification--" + passwordStrength}>
					<li className="notification-dot password-strength-notification__item"></li>
					<li className="notification-dot password-strength-notification__item"></li>
					<li className="notification-dot password-strength-notification__item"></li>
					<li className="notification-dot password-strength-notification__item"></li>
				</ul>
			</span>
		);
	}

	renderCountries()
	{
		if ( this._countries != null )
			return this._countries;

		this._countries	= 	_.map( blapp.country.arrCountry, ( c, key ) => (<option value={c.codeCountry} key={key}>{c.strCountryName}</option>) );

		return this._countries;
	}

	renderStates()
	{
		if ( this.state.typeState == 1 )
		{
			return ( 
				<select className={"select l-full-width" + (this.state.selectedState == -1 ? " border-color--primaryRed l-margin-bottom--xs" : "")} value={this.state.selectedState} onChange={(e)=>this.setState({selectedState: e.target.value})}>
					<option key={-1} value={-1}>{$T("SELECT_STATE", [ this.state.strTitleState ] )}</option>
					{this._states}
				</select>
			);
		}		
		else if ( this.state.typeState == 2 )
		{
			return (
				<InputLabelSet classes="l-margin-bottom l-margin-top--sm" data={{id: "logindlg_l_statename", focus: true, label: this.state.strTitleState, inputValue: this.state.stateManual, onChangeFunc: (newval)=>this.setState( {stateManual: newval } ) }}/>
			);
		}

		return null;
	}

	updateCountry = (e) =>
	{
		var	newCountry	= e.target.value;

		if ( newCountry != this.state.selectedCountry )
		{
			this.setState( { selectedCountry: newCountry } );
			this.updateStates( newCountry );
		}

	}

	updateStates = ( newCountry ) =>
	{
		var	countryInfo			= blapp.country.get( newCountry );
		var	typeState			= 0;
		var	strTitleState		= "state";
		var	selectedState		= -1;
		var	hasStateGroup		= 0;

		if ( countryInfo != null )
		{
			var addressFormat	= blapp.address.getFormat( countryInfo.idAddressFormat );
			var	statesNew		= _.sortBy( countryInfo.arrStatesNew, [ (s) => { if ( s.hasOwnProperty( "idStateNewParent" ) && s.idStateNewParent > 0 ) return s.idStateNewParent; return 999999; }, "strStateName" ] );
			var statesElem		= [];
			var statesGroup		= [];
			var	prevGroupID		= -1;
			var	curGroup			= null;

			if ( addressFormat != null )
				strTitleState	= addressFormat.strTitleState;

			if ( addressFormat != null && ( addressFormat.typeState == 1 || addressFormat.typeState == 2 ) )
			{
				if ( statesNew.length > 0 )
				{
					for ( var i = 0; i < statesNew.length; ++ i )
					{
						var	curState	= statesNew[ i ];

						if ( curState.hasOwnProperty( "idStateNewParent" ) && curState.idStateNewParent > 0 )
						{
							hasStateGroup	= 1;

							if ( prevGroupID != curState.idStateNewParent )
							{
								prevGroupID	= curState.idStateNewParent;

								if ( curGroup != null )
									statesGroup.push( curGroup );

								curGroup	= blapp.country.getStateNew( prevGroupID );

								if ( curGroup != null )
								{
									curGroup				= _.clone( curGroup );
									curGroup.childs	= [];								
								}
							}
							
							if ( curGroup != null )
								curGroup.childs.push( curState );
						}
						else if ( hasStateGroup == 0 )
						{
							if ( curGroup != null )
								statesGroup.push( curGroup );

							curGroup				= _.clone( curState );
							curGroup.childs	= [];
						}
					}

					if ( curGroup != null )
						statesGroup.push( curGroup );

					statesGroup	= _.sortBy( statesGroup, [ "strStateName" ] );
					statesElem	= _.map( 
										statesGroup
									, 	function ( g )
										{
											if ( g.childs.length == 0 )
												return ( <option key={g.idStateNew} value={g.idStateNew}>{g.strStateName}</option> );
											return (
												<optgroup key={g.idStateNew} label={g.strStateName}>
												{ _.map( g.childs, ( gc ) => <option key={gc.idStateNew} value={gc.idStateNew}>{gc.strStateName}</option> ) }
												</optgroup>
											);
										}
									);

					typeState		= 1;
				}
				else
				{
					typeState		= 2;

				}
			}
			else
			{
				typeState	= 0;
			}
		}
		else
		{
			typeState	= 0;
		}
	
		this._states	= statesElem;

		if ( newCountry == blapp.session.codeCountryDetected && blapp.session.idStateDetected > 0 )
		{
			var	stateLegacy	= blapp.country.getStateLegacy( blapp.session.idStateDetected );
			if ( stateLegacy != null )
				selectedState	= stateLegacy.idStateNew;
		}

		this.setState( { typeState: typeState, strTitleState: strTitleState, selectedState: selectedState } );
	}

	updateEmailAddress = (newval) =>
	{
		this.setState({emailAddress: newval});

		if ( blapp.util.isValidEmailAddr( newval ) )
			this.funcValidate( newval );
	}

	updateUsername = (newval) => 
	{
		var	newval	= newval.replace( /[^a-zA-Z0-9\._]/g, '' );
		this.setState( {username: newval} );

		this.funcValidate( newval );
	}

	updateLoginname = (newval) => 
	{
		this.setState( {loginname: newval} );
	}


	updatePassword = (newval) =>
	{
		this.setState({password: newval});
		this.updatePasswordStrength(newval);
	}

	updatePasswordStrength( newval ) 
	{
		const 	password = newval;
		let 	strength = 0;

		const digit 		= /\d/g;
		const uppercase = /[A-Z]/g;
		const special 	= /[\!\@\#\$\%\^\&\*\)\(\+\=\.\_\-\;\:\[\]\{\}\?\<\>\,]/g;

		strength = password.match(digit) ? strength + 1 : strength;
		strength = password.match(uppercase) ? strength + 1 : strength;
		strength = password.match(special) ? strength + 1 : strength;

		this.setState({passwordStrength: strength});
	}

	changeStayLoggedIn = (e) =>
	{
		this.setState({stayLoggedIn: e.target.checked});
	}

	changeMarketingEmails = (e) =>
	{
		this.setState({marketingEmails: e.target.value});
	}

	login = () =>
	{
		if ( this._isProcessing == false )
		{
			this._isProcessing	= true;
			blapp.session.login( this.state.loginname, this.state.password, this.state.stayLoggedIn, ( data ) => this.onLoginCallback( data ) );
		}
	}

	register = () =>
	{
		if(this.state.marketingEmails == '')
		{
			this.setState({errorMarketing: true});
			return;
		}
		else{
			this.setState({errorMarketing: false});
		}
		if ( this._isProcessing == false )
		{
			this._isProcessing	= true;

			blAjax.call(
				"/signup.ajax"
			,	{
					strEmailAddr:	this.state.emailAddress
				,	strUsername:	this.state.username
				,	strPassword:	this.state.password
				,	codeCountry:	this.state.selectedCountry
				,	strState:		this.state.typeState == 0 ? "" : ( this.state.typeState == 1 ? this.state.selectedState : this.state.stateManual )
				,	urlReturn:		window.location.href
				,	strPageID:		blapp.util.getPageID()
				,	bMktgEmail:	this.state.marketingEmails
				}
			).then(
				( data ) => 
				{
					this._isProcessing	= false;

					if ( data.result == "EC_OK" )
					{
						this.setState( { errorRegisterMsg: '' } );
						if ( data.session != null )
							blapp.session.set( data.session, true );
						blapp.refs.get( "header" ).toggleMenu( 'confirm_email' );
					}
					else
					{
						this.setState( { errorRegisterMsg: this.convertToErrorMsg( data.result ) } );
					}
				}
			).catch(
				( err ) =>
				{
					this._isProcessing	= false;
					this.setState( { errorRegisterMsg: err } );
				}
			);
		}
	}

	onLoginCallback = ( data )=>
	{
		this._isProcessing	= false;

		if( data.returnCode ) {
			this.setState( { errorLoginMsg: data.message, showDeactivatedError: false } );
		}else if( data == "EC_LOGIN_ACC_RECOVERY_REQUIRED" ) 
		{
			this.setState({showRecovery: true});
		}else if( data == "EC_LOGIN_PASSWORD_RESET_REQUIRED" ) 
		{
			this.setState({showUpdatePwd: true});
		}else if ( data == "EC_OK" )
		{
			this.setState( {errorLoginMsg: '', showDeactivatedError: false} );
			blapp.refs.get( "header" ).toggleMenu( 'login' );
			window.rebuildIconNav();
			window.rebuildCartNav();
			window.rebuildSearchDropdown();
			
			if (this.props.callback) {
				this.props.callback();
			}
			
		}
		else if ( data == "EC_LOGIN_DEACTIVATED_USER" )
		{
			this.setState( {errorLoginMsg: '', showDeactivatedError: true} );
		}
		else
		{
			this.setState( { errorLoginMsg: this.convertToErrorMsg( data ), showDeactivatedError: false } );
		}
	}

	convertToErrorMsg = ( ec ) =>
	{
		switch ( ec )
		{
		case "EC_LOGIN_NOT_SUPPORTED":		return $T( "ERR_LOGIN_NOT_SUPPORTED" );
		case "EC_LOGIN_ALREADY_LOGGEDIN":	return $T( "ERR_LOGIN_ALREADY_LOGGEDIN" );
		case "EC_LOGIN_INVALID_PARAM":		return $T( "ERR_LOGIN_INVALID_PARAM" );
		case "EC_LOGIN_IDPWD_MISMATCH":		return $T( "ERR_LOGIN_IDPWD_MISMATCH" );
		case "ERR_NO_TOKEN":		return $T( "ERR_NO_TOKEN" );
		case "EC_LOGIN_REVOKED_USER":		return $T( "ERR_LOGIN_REVOKED_USER" );
		case "EC_LOGIN_BLOCKED_MACHINE":    return $T( "ERR_LOGIN_BLOCKED_MACHINE" );
		case "EC_LOGIN_COMPROMISED_CREDENTIAL": return $T( "ERR_LOGIN_COMPROMISED_CREDENTIAL" );
		case "EC_LOGIN_BLOCKED_COUNTRY":		return $T( "ERR_LOGIN_BLOCKED_COUNTRY" );

		case "EC_INVALID_PARAM":			return $T( "ERR_INVALID_PARAM" );
		case "EC_SIGNUP_INVALID_EMAIL":		return $T( "ERR_SIGNUP_INVALID_EMAIL" );
		case "EC_SIGNUP_INVALID_USERNAME":	return $T( "ERR_SIGNUP_INVALID_USERNAME" );
		case "EC_SIGNUP_INVALID_PASSWORD":	return $T( "ERR_SIGNUP_INVALID_PASSWORD" );
		case "EC_SIGNUP_USERNAME_EXISTS":	return $T( "ERR_SIGNUP_USERNAME_EXIST" );
		case "EC_SIGNUP_EMAIL_EXISTS":		return $T( "ERR_SIGNUP_EMAIL_EXIST" );
		case "EC_SIGNUP_INVALID_COUNTRY":	return $T( "ERR_SIGNUP_INVALID_COUNTRY" );
		case "EC_SIGNUP_EMAIL_FAILURE":		return $T( "ERR_SIGNUP_EMAIL_FAILURE" );	
		}

		return $T( "ERR_UNKNOWN", [ ec ] );
	}
}

var $T = BLComponent.createTextMap( 
	{
		"LOG_IN":
			{
				"en":	"Log in"
			,	"kr":	"로그인"
			,	"es":	"Entrar"
			}
	,	"REGISTER":
			{
				"en":	"Register"
			,	"kr":	"회원 가입"
			,	"es":	"Registrarse"
			}
	,	"LBL_USERID":
			{
				"en":	"Username or email"
			,	"kr":	"유저네임 또는 이메일"
			,	"es":	"Correo o Nombre de usuario"
			}
	,	"LBL_PASSWORD":
			{
				"en":	"Password"
			,	"kr":	"비밀번호"
			,	"es":	"Contraseña"
			}			
	,	"STAY_LOGGEDIN":
			{
				"en":	"Stay logged in for this browser"
			,	"kr":	"자동로그인"
			,	"es":	"Mantener sesión iniciada"
			}
	,	"HAVING_TROUBLE":
			{
				"en":	"Having trouble logging in?"
			,	"kr":	"로그인 문제 해결"
			,	"es":	"¿Tienes problemas accediendo a tu cuenta?"
			}
	,	"FORGOT_PASSWORD":
			{
				"en":	"Forgot your password?"
			,	"kr":	"비밀번호 찾기"
			,	"es":	"¿Olvidaste tu contraseña?"
			}
	,	"NOT_A_MEMBER":
			{
				"en":	"Not a member yet?"
			,	"kr":	"아직 회윈이 아니신가요?"
			,	"es":	"¿Aún no eres miembro?"
			}
	,	"ACCOUNT":
			{
				"en":	"Account"
			,	"kr":	"계정 정보"
			,	"es":	"Cuenta"
			}
	,	"LBL_EMAILADDRESS":
			{
				"en":	"Email address"
			,	"kr":	"이메일 주소"
			,	"es":	"Correo electrónico"
			}
	,	"LBL_USERNAME":
			{
				"en":	"Username"
			,	"kr":	"유저네임"
			,	"es":	"Nombre de usuario"
			}
	,	"LOCATION":
			{
				"en":	"Location"
			,	"kr":	"지역 정보"
			,	"es":	"Ubicación"
			}
	,	"SELECT_STATE":
			{
				"en":	"-- Select {{$0}} --"
			,	"kr":	"-- {{$0}} 선택 --"
			,	"es":	"-- Selecciona {{$0}} --"
			}

	,	"CONSENT":
			{
				"en":	(<span>By creating an account, you confirm you are at least 18 years old and accept our <a target="_blank" href='https://www.bricklink.com/help.asp?helpID=1919'>Terms of Service Agreement</a> and <a target="_blank" href='https://www.bricklink.com/help.asp?helpID=47'>Privacy Policy</a>.</span>)
			,	'kr':	(<span>회원 가입 시, 만 18세 이상임과 브릭링크 <a target="_blank" href='https://www.bricklink.com/help.asp?helpID=1919'>이용약관</a> 및 <a target="_blank" href='https://www.bricklink.com/help.asp?helpID=47'>개인정보취급방침</a>에 동의한 것으로 간주합니다.</span>)
			,	"es":	(<span>Al crear una cuenta, confirmas que eres mayor de 18 años y aceptas nuestras <a target="_blank" href='https://www.bricklink.com/help.asp?helpID=1919'>condiciones de uso</a> y <a target="_blank" href='https://www.bricklink.com/help.asp?helpID=47'>política de privacidad</a>.</span>)
			}
	,	"CREATE_ACCOUNT":
			{
				"en":	"Create account"
			,	"kr":	"계정 생성"
			,	"es":	"Crear cuenta"
			}
	,	"ALREADY_MEMBER":
			{
				"en":	"Already a member?"
			,	"kr":	"이미 회원이신가요?"
			,	"es":	"¿Ya eres miembro?"
			}
	,	"EMAIL_NOTE":
			{
				"en":	"A confirmation email will be sent to this email address."
			,	"kr":	"본 이메일 주소로 확인 이메일을 보냅니다."
			,	"es":	"Un correo de confirmación será enviado a esta dirección."
			}
	,	"USERNAME_NOTE":
			{
				"en":	"Only use letters, numbers, periods (.), or underscores (_)."
			,	"kr":	"알파벳, 숫자, 마침표(.), 밑줄(_)만 허용됩니다."
			,	"es":	"Solo se permiten letras, números, puntos (.) o guiones bajos (_)."
			}
	,	"PASSWORD_NOTE":
			{
				"en":	"Your password must be 8-15 characters long without spaces and is case sensitive. Use only letters, numbers, and certain special characters."
			,	"kr":	""
			,	"es":	""
			}
	, 	"PASSWORD_STRENGTH":
			{
				"en":	"Password Strength"
			,	"kr":	"암호 적합성"
			,	"es":	"Seguridad de la contraseña"
			}
	,	"PWD_STRENGTH_WEAK":
			{
				"en":	"Weak"
			,	"kr":	"최하"
			,	"es":	"Débil"
			}
	,	"PWD_STRENGTH_MODEST":
			{
				"en":	"Modest"
			,	"kr":	"중하"
			,	"es":	"Regular"
			}
	,	"PWD_STRENGTH_GOOD":
			{
				"en":	"Good"
			,	"kr":	"중상"
			,	"es":	"Buena"
			}
	,	"PWD_STRENGTH_STRONG":
			{
				"en":	"Strong"
			,	"kr":	"최상"
			,	"es":	"Fuerte"
			}

	,	"STATE_NOTE":
			{
				"en":	"Please select a state."
			,	"kr":	"지역을 선택하세요."
			,	"es":	"Por favor selecciona un estado."
			}

	,	"ERR_LOGIN_NOT_SUPPORTED":
			{
				"en":	"Invalid login method!"
			,	"kr":	"유효하지 않는 로그인 방식입니다."
			,	"es":	"Método de acceso incorrecto!"
			}
	,	"ERR_LOGIN_ALREADY_LOGGEDIN":
			{
				"en":	"Already Logged-in!"
			,	"kr":	"이미 로그인 된 상태입니다."
			,	"es":	"Ya has accedido!"
			}
	,	"ERR_LOGIN_INVALID_PARAM":
			{
				"en":	"Invalid Parameter!"
			,	"kr":	"잘못된 파라미터입니다."
			,	"es":	"Parámetro inválido!"
			}
	,	"ERR_LOGIN_IDPWD_MISMATCH":
			{
				"en":	"ID or Password Mismatch!"
			,	"kr":	"ID 또는 암호가 일치하지 않습니다."
			,	"es":	"Usuario o contraseña incorrectos"
			}
	, "ERR_NO_TOKEN":
			{
				"en":	"Error logging in. Please try again in 30 minutes."
			,	"kr":	""
			,	"es":	""
			}
	,	"ERR_LOGIN_REVOKED_USER":
			{
				"en":	"Revoked User!"
			,	"kr":	"취소된 유저입니다."
			,	"es":	"Usuario cancelado!"
			}
	,	"ERR_LOGIN_BLOCKED_MACHINE":
            {
                "en":	"Blocked Machine!"
            ,	"kr":	"이용 정지 된 장비입니다."
            ,	"es":	"Máquina bloqueada!"
            }
	,	"ERR_LOGIN_COMPROMISED_CREDENTIAL":
            {
                "en":	"Error logging in. Please update your password or log in from a different device."
            ,	"kr":	"로그인 에러. 비밀번호를 변경하거나 다른 장비에서 로그인 해주세요."
            ,	"es":	"Error al iniciar sesión. Actualice su contraseña o inicie sesión desde un dispositivo diferente."
            }
	,	"ERR_LOGIN_BLOCKED_COUNTRY":
			{
				"en":	"Account not found"
			,	"kr":	"존재하지 않는 계정입니다."
			,	"es":	"Cuenta no encontrada"
			}
	,	"ERR_UNKNOWN":
			{
				"en":	"Unknown Error! ({{$0}})"
			,	"kr":	"알수 없는 에러입니다. ({{$0}})"
			,	"es":	"Error desconocido! ({{$0}})"
			}
	,	"ERR_INVALID_PARAM":
			{
				"en":	"Input value is invalid."
			,	"kr":	"입력값이 유효하지 않습니다."
			,	"es":	"El valor introducido no es válido."
			}
	,	"ERR_INVALID_EMAIL":
			{
				"en":	"Email address is invalid."
			,	"kr":	"유효하지 않은 이메일 주소입니다."
			,	"es":	"La dirección de correo no es válida."
			}
	,	"ERR_INVALID_USERNAME":
			{
				"en":	"Username is invalid."
			,	"kr":	"유효하지 않은 유저네임입니다."
			,	"es":	"El usuario no es válido."
			}
	,	"ERR_INVALID_PASSWORD":
			{
				"en":	"Password is invalid."
			,	"kr":	"유효하지 않은 암호입니다."
			,	"es":	"La contraseña no es válida."
			}
	,	"ERR_SIGNUP_EMAIL_EXIST":
			{
				"en":	"This email is already in use."
			,	"kr": 	"이미 사용중인 이메일 주소입니다."
			,	"es":	"La dirección de correo ya está registrada."
			}
	,	"ERR_SIGNUP_USERNAME_EXIST":
			{
				"en":	"A user with that name already exists."
			,	"kr":	"이미 사용중인 유저네임입니다."
			,	"es":	"Ya existe un usuario con este nombre."
			}
	,	"ERR_SIGNUP_USERNAME_TOO_LONG":
			{
				"en":	"Username is exceeding 15 characters."
			,	"kr":	"유저네임이 15자를 초과하였습니다."
			,	"es":	"El nombre de usuario excede 15 caracteres."
			}
	,	"ERR_SIGNUP_INVALID_COUNTRY":
			{
				"en":	"Invalid Country!"
			,	"kr":	"잘못된 국가입니다."
			,	"es":	"El país no es válido."
			}
	,	"ERR_SIGNUP_EMAIL_FAILURE":
			{
				"en":	"Email Failure!"
			,	"kr":	"이메일 발송에 실패하였습니다."
			,	"es":	"Error procesando el correo."
			}
	,	"ERR_SIGNUP_INVALID_PASSWORD":
			{
				"en":	"Password is not valid. It may contain unsupported characters."
			,	"kr":	""
			,	"es":	"La contraseña no es valida. Puede contener caracteres no soportados."
			}
	,	"MARKETING_EMAILS":
			{
				"en":	"Marketing emails"
			,	"kr":	""
			,	"es":	""
			}
	,	"MARKETING_YES":
			{
				"en":	"Yes, I want to receive marketing emails about featured stores, new items, and new BrickLink features."
			,	"kr":	""
			,	"es":	""
			}
	,	"MARKETING_NO":
			{
				"en":	"No, I do not want to receive marketing emails about featured stores, new items, and new BrickLink features."
			,	"kr":	""
			,	"es":	""
			}
	,	"MARKETING_ERROR":
			{
				"en":	"Please select Yes or No for marketing emails to procceed."
			,	"kr":	""
			,	"es":	""
			}
	}
);
